import IActivity from "interfaces/IActivity";
import { IActivityWizardDetails } from "pages/masterdata/components/activities/interfaces/IActivityWizard";

export interface IActivityTypeStoreState {
  activities?: IActivity[];
  selectedActivity?: IActivityWizardDetails;
}

export const initialActivityTypeStoreState: IActivityTypeStoreState = {};
